export const isConductor = (
    window.location.hostname.indexOf('conductor') !== -1
);
